import React, {useEffect, useRef} from 'react';

import {loadMapsApi} from './GoogleMapView';

export const AddressMapView: React.FC<{address: string}> = ({address}) => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!mapRef.current) return;
      try {
        await loadMapsApi();
        if (cancelled || !mapRef.current) return;

        const g = (window as any).google;
        const {Map} = await g.maps.importLibrary('maps');
        const {AdvancedMarkerElement} = await g.maps.importLibrary('marker');
        const {Geocoder} = await g.maps.importLibrary('geocoding');

        const geocoder = new Geocoder();
        const result = await geocoder.geocode({address});
        if (cancelled || !mapRef.current || !result.results.length) return;

        const position = result.results[0].geometry.location;
        const map = new Map(mapRef.current, {
          zoom: 16,
          center: position,
          mapTypeControl: false,
          panControl: false,
          mapId: 'cf2b62356780d34a4438e3f2',
        });

        new AdvancedMarkerElement({map, position});
      } catch (e) {
        console.error('Google Maps failed to initialize:', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [address]);

  return <div ref={mapRef} className="size-full" />;
};
